import Home_SectionOne from "./Home_SectionOne";
import "./Home.scss";
import Home_SectionTwo from "./Home_SectionTwo";
import Home_SectionThree from "./Home_SectionThree";
import Home_SectionFour from "./Home_SectionFour";
import Home_SectionFive from "./Home_SectionFive";
import Home_SectionSix from "./Home_SectionSix";

function Home() {
  return (
    <>
      <main>
        <Home_SectionOne />
        <Home_SectionTwo />
        <Home_SectionThree />
        <Home_SectionFour />
        <Home_SectionFive />
        <Home_SectionSix />
      </main>
    </>
  );
}

export default Home;
